module.exports = __webpack_public_path__ + "img/icon_2.3b27fd4f.png";